import React from 'react';
import {
  ApButtonGroup,
  ApButtonDanger,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import { StyledModal } from './ChangeCategoryModal.styles';

interface IProps {
  isOpen: boolean;
  onSubmit(): void;
  onClose(): void;
}

export const ChangeCategoryModal: React.FC<IProps> = ({
  onClose,
  onSubmit,
  isOpen,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      hasClosed={onClose}
      footer={({ handleClose }) => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={handleClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onSubmit}>Change category</ApButtonDanger>
          </ApButtonGroup>
        );
      }}
    >
      By changing category of spend you will lose current allocations
    </StyledModal>
  );
};
